import { getAdminData } from 'app/providers/auth-provider';
import { AdminResponseDtoRoleEnum } from 'shared/api';

const ALLOWED_ROLES: AdminResponseDtoRoleEnum[] = [
  AdminResponseDtoRoleEnum.Superadmin,
  AdminResponseDtoRoleEnum.Admin,
];

export const canDeletePatientProfile = (): boolean => {
  const { userRole } = getAdminData();
  return ALLOWED_ROLES.includes(userRole);
};
